import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import FormularzUrzadzen from './FormularzUrzadzen';
import OknoEdycji from './OknoEdycji';
import FormularzAdresu from './FormularzAdresu';
import './klienciStyle/SzczegolyKlienta.css';
import FormularzZlecenia from '../zlecenia/FormularzZlecenia';
import { FiX } from 'react-icons/fi'; 
import SzczegolyZlecenia from '../zlecenia/SzczegolyZlecenia';
import SzczegolyKlientaTabela from '../zlecenia/SzczegolyZleceniaTabela';
import { hasAnyPermission, hasPermission } from '../../auth/permissionUtils';


const API_URL = process.env.REACT_APP_API_URL;

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}


function SzczegolyKlienta({uzytkownik}) {
  const canCreateClient = hasPermission(uzytkownik, 'clients_create');
  const canEditClient = hasAnyPermission(uzytkownik, ['clients_edit_all', 'clients_edit_own']);
  const canDeleteClient = hasAnyPermission(uzytkownik, ['clients_delete_all', 'clients_delete_own']);
  const canCreateOrder = hasPermission(uzytkownik, 'orders_create');
  const canManageFiles = hasPermission(uzytkownik, 'files_manage');

  const { klientId } = useParams();
  const [klient, setKlient] = useState(null);
  const [adresy, setAdresy] = useState([]);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [expandedAddresses, setExpandedAddresses] = useState({});
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [editAddressData, setEditAddressData] = useState({});
  const [urzadzenia, setUrzadzenia] = useState([]);
  const [showDeviceForm, setShowDeviceForm] = useState(false);
  const [editingDeviceId, setEditingDeviceId] = useState(null);
  const [editDeviceData, setEditDeviceData] = useState({});
  const [editingClient, setEditingClient] = useState(false);
  const [editClientData, setEditClientData] = useState({});
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [clientFiles, setClientFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const fileInputRef = useRef(null);
  const [existingFiles, setExistingFiles] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewPos, setPreviewPos] = useState({ x: 0, y: 0 });
  const [previewType, setPreviewType] = useState(null); // 'image' | 'pdf'
  const [zleceniaKlienta, setZleceniaKlienta] = useState([]);
  const [pokazZlecenieId, setPokazZlecenieId] = useState(null);

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchZlecenia = async () => {
      try {
        const res = await axios.get(`${API_URL}/zlecenia?klientId=${klientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setZleceniaKlienta(res.data);
      } catch (err) {
        console.error('Błąd pobierania zleceń klienta:', err);
      }
    };

    fetchZlecenia();
  }, [klientId, token]);
  
  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/pliki/klienci?id_klienta=${klientId}`, 
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setExistingFiles(res.data);
      } catch (err) {
        console.error('Błąd pobierania listy plików:', err);
      }
    };
    fetchFiles();
  }, [klientId, token]);

  //////////////////

    // 1. Pobranie i pobranie pliku
    const handleDownload = async (file) => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(
          `${API_URL}/pliki/${file.id_pliku}`,
          {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        // Tworzymy URL i wymuszamy pobranie
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.nazwa_oryginalna;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error('Błąd pobierania pliku:', err);
        alert('Nie udało się pobrać pliku');
      }
    };
  
    // 2. Ładowanie miniaturki na hover
    const handleMouseEnter = async (file, e) => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(
          `${API_URL}/pliki/${file.id_pliku}`,
          {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        const mime = file.typ_pliku;
        const blob = new Blob([res.data], { type: mime });
        const url = window.URL.createObjectURL(blob);
        setPreviewUrl(url);
        setPreviewType(mime.startsWith('image/') ? 'image' : 'pdf');
        // ustawiamy pozycję tooltipu
        setPreviewPos({ x: e.clientX + 10, y: e.clientY + 10 });
      } catch {
        setPreviewUrl(null);
      }
    };
    const handleMouseMove = (e) => {
      setPreviewPos({ x: e.clientX + 10, y: e.clientY + 10 });
    };
    const handleMouseLeave = () => {
      if (previewUrl) {
        window.URL.revokeObjectURL(previewUrl);
        setPreviewUrl(null);
      }
    };

  //////////////////

  // Otwiera dialog wyboru plików
  const handleChooseFilesClick = () => {
    fileInputRef.current.click();
  };

  // Dodaje wybrane pliki (unika duplikatów)
  const handleClientFilesChange = e => {
    const files = Array.from(e.target.files);
    setClientFiles(prev =>
      [...prev, ...files].filter((f, i, arr) =>
        arr.findIndex(x => x.name === f.name && x.size === f.size) === i
      )
    );
  };

  // Usuwa pojedynczy plik z listy
  const handleRemoveFile = idx => {
    setClientFiles(prev => prev.filter((_, i) => i !== idx));
  };

  // Upload wszystkich plików dla tego klienta
  const handleUploadFiles = async () => {
    if (!clientFiles.length) return;
    setUploadingFiles(true);
    try {
      const token = localStorage.getItem('token');
      await Promise.all(clientFiles.map(file => {
        const formData = new FormData();
        formData.append('plik', file);
        formData.append('nazwa_pliku', file.name);
        formData.append('idPowiazania', klient.id_klient);
        return axios.post(
          `${API_URL}/pliki/upload/klient`,
          formData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }));
      // Po pomyślnym uploadzie możesz ponownie pobrać listę plików lub wyczyścić
      setClientFiles([]);
      alert('Pliki zostały przesłane.');
    } catch (err) {
      console.error('Błąd uploadu plików:', err);
      alert('Wystąpił błąd podczas przesyłania plików.');
    } finally {
      setUploadingFiles(false);
    }
  };

  // 4. Usuwanie pliku klienta
  const handleDeleteClientFile = async (file) => {
  const confirmed = window.confirm(`Czy na pewno chcesz usunąć plik "${file.nazwa_oryginalna}"?`);
  if (!confirmed) return;
    try {
      await axios.delete(`${API_URL}/pliki/${file.id_pliku}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // odśwież listę plików w stanie
      setExistingFiles(prev => prev.filter(f => f.id_pliku !== file.id_pliku));
      alert('Plik został usunięty.');
    } catch (err) {
    console.error('Błąd usuwania pliku:', err);
      alert('Nie udało się usunąć pliku.');
    }
  };


  useEffect(() => {
    const fetchDaneKlienta = async () => {
      try {
        const [klientResponse, adresyResponse, urzadzeniaResponse] = await Promise.all([
          axios.get(`${API_URL}/klienci/${klientId}`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/adresy?id_klient=${klientId}`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/urzadzenia?id_klient=${klientId}`, { headers: { Authorization: `Bearer ${token}` } })
        ]);

        setKlient(klientResponse.data);
        setAdresy(adresyResponse.data);
        setUrzadzenia(urzadzeniaResponse.data);
      } catch (err) {
        console.error('Błąd pobierania danych klienta:', err);
        setError(err);
      }
    };

    fetchDaneKlienta();
  }, [klientId, token]);
////////////Edytowanie danych klietna//////////////////////
  const handleStartEditClient = () => {
    setEditingClient(true);
    setEditClientData(klient);
  };

  const handleCancelEditClient = () => {
      setEditingClient(false);
      setEditClientData({});
  };

  const handleSaveClient = async () => {
      try {
        const { id_klient, data_dodania, data_ostatniej_modyfikacji, ...clientDataToSend } = editClientData;
        const response = await axios.put(`${API_URL}/klienci/${klient.id_klient}`, clientDataToSend, {
            headers: { Authorization: `Bearer ${token}` }
        });
        setKlient(response.data);
        setEditingClient(false);
      } catch (error) {
          console.error("❌ Błąd edycji klienta:", error.response ? error.response.data : error);
      }
  };
////////////Edytowanie danych klietna//////////////////////

////////////Dodawanie adresu//////////////////////
  const handleAddAddress = async (addressData) => {
    try {
      const response = await axios.post(`${API_URL}/adresy`, addressData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAdresy([...adresy, response.data]);
      setShowAddressForm(false);
    } catch (error) {
      console.error('Błąd dodawania adresu:', error.response ? error.response.data : error);
    }
  };
////////////Dodawanie adresu//////////////////////



////////////Usuwanie Adresu//////////////////////
const handleDeleteAddress = async (adresId) => {
  const confirmDelete = window.confirm("Czy na pewno chcesz usunąć ten adres?");
  if (!confirmDelete) return;

  try {
    await axios.delete(`${API_URL}/adresy/${adresId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setAdresy(adresy.filter(adres => adres.id_adres !== adresId));
  } catch (error) {
    console.error('Błąd usuwania adresu:', error);
  }
};
  ////////////Usuwanie Adresu//////////////////////

  ////////////Edytowanie Adresu//////////////////////
  const handleStartEditAddress = (adres) => {
    const { id_adres, ...addressDataWithoutId } = adres;
    setEditingAddressId(id_adres);
    setEditAddressData(addressDataWithoutId);
  };

  const handleCancelEditAddress = () => {
    setEditingAddressId(null);
    setEditAddressData({});
  };

  const handleSaveAddress = async () => {
    try {
        const { data_ostatniej_modyfikacji, ...addressDataToSend } = editAddressData;

        const response = await axios.put(`${API_URL}/adresy/${editingAddressId}`, addressDataToSend, {
            headers: { Authorization: `Bearer ${token}` }
        });

        setAdresy(prev => prev.map(adres => 
            adres.id_adres === editingAddressId ? response.data : adres
        ));

        setEditingAddressId(null);
        setEditAddressData({});
    } catch (error) {
        console.error("❌ Błąd edycji adresu:", error.response ? error.response.data : error);
    }
  };
  ////////////Edytowanie Adresu//////////////////////

  ////////////Pokazywanie urzadzeń na pod adresem//////////////////////
  const toggleExpandAddress = async (adresId) => {
    setExpandedAddresses(prev => ({
      ...prev,
      [adresId]: !prev[adresId]
    }));

    if (!urzadzenia[adresId]) {
      try {
        const response = await axios.get(`${API_URL}/urzadzenia?id_adres=${adresId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setUrzadzenia(prev => ({
          ...prev,
          [adresId]: response.data
        }));
      } catch (error) {
        console.error('Błąd pobierania urządzeń:', error);
      }
    }
  };
  ////////////Pokazywanie urzadzeń na pod adresem//////////////////////

////////////Dodawanie Urządzenia//////////////////////
  const handleAddDevice = async (deviceData) => {
    console.log('Wysyłane zapytania API', deviceData);
    try {
      const response = await axios.post(`${API_URL}/urzadzenia`, deviceData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('Odpowiedź API:', response.data);
      setUrzadzenia(prev => ({
        ...prev,
        [deviceData.id_adres]: [...(prev[deviceData.id_adres] || []), response.data] // Upewniamy się, że to tablica
    }));
      closeAddDeviceModal(); // Zamknij modal po pomyślnym dodaniu
    } catch (error) {
      console.error('Błąd dodawania urządzenia:', error);
    }
  };
  ////////////Dodawanie Urządzenia//////////////////////

  ////////////Edytowanie Urządzenia//////////////////////
  const handleStartEdit = (device) => {
    setEditingDeviceId(device.id_urzadzenie);
    setEditDeviceData(device);
  };

  const handleCancelEdit = () => {
    setEditingDeviceId(null);
    setEditDeviceData({});
  };

  const handleSaveDevice = async () => {
    try {
        const { id_urzadzenie, ...deviceDataToSend } = editDeviceData;

        const response = await axios.put(`${API_URL}/urzadzenia/${id_urzadzenie}`, deviceDataToSend, {
            headers: { Authorization: `Bearer ${token}` }
        });

        console.log('Odpowiedź API:', response.data);

        setUrzadzenia(prev => ({
            ...prev,
            [editDeviceData.id_adres]: prev[editDeviceData.id_adres].map(u =>
                u.id_urzadzenie === id_urzadzenie ? response.data : u
            )
        }));

        setEditingDeviceId(null);
        setEditDeviceData({});
    } catch (error) {
        console.error('Błąd edycji urządzenia:', error.response ? error.response.data : error);
    }
  };

  const openAddDeviceModal = (adresId) => {
    setShowDeviceForm(adresId);
  };

  const closeAddDeviceModal = () => {
    setShowDeviceForm(null);
  };
////////////Edytowanie Urządzenia//////////////////////

  ////////////Usuwanie Urządzenia//////////////////////
  const handleDeleteDevice = async (urzadzenieId, adresId) => {
    const confirmDelete = window.confirm("Czy na pewno chcesz usunąć to urządzenie?");
    if (!confirmDelete) return;
  
    console.log(`Usuwam urządzenie ID: ${urzadzenieId}, dla adresu ID: ${adresId}`);
    try {
      const response = await axios.delete(`${API_URL}/urzadzenia/${urzadzenieId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      console.log('Odpowiedź API:', response.data);
  
      setUrzadzenia(prev => ({
        ...prev,
        [adresId]: prev[adresId].filter(u => u.id_urzadzenie !== urzadzenieId)
      }));
  
      console.log(`Po usunięciu, nowe urządzenia:`, urzadzenia[adresId]);
    } catch (error) {
      console.error('Błąd usuwania urządzenia:', error.response ? error.response.data : error);
    }
  };
  ////////////Usuwanie Urządzenia//////////////////////


  if (error) return <div>Wystąpił błąd: {error.message}</div>;
  if (!klient) return <div>Ładowanie...</div>;

  return (
    <div>
      <div className='client-header'>
        <h2>Dane klienta: {klient.imie} {klient.nazwisko}</h2>
        <div className="client-buttons-container">
          {canEditClient ? <button onClick={handleStartEditClient}>Edytuj dane klienta</button> : null}
          {canEditClient ? <button onClick={() => setShowAddressForm(true)}>Dodaj adres</button> : null}
          {canCreateOrder ? <button onClick={() => setShowOrderForm(true)}>Dodaj zlecenie</button> : null}
        </div>
      </div>
      {editingClient ? (
        <div className="client-form-grid">
          <section className="form-section">
            <h4>Dane podstawowe</h4>
            <label>Imię</label>
            <input
              type="text"
              value={editClientData.imie}
              onChange={e => setEditClientData({ ...editClientData, imie: e.target.value })}
            />
            <label>Nazwisko</label>
            <input
              type="text"
              value={editClientData.nazwisko}
              onChange={e => setEditClientData({ ...editClientData, nazwisko: e.target.value })}
            />
            <label>Email</label>
            <input
              type="email"
              value={editClientData.adres_email}
              onChange={e => setEditClientData({ ...editClientData, adres_email: e.target.value })}
            />
            <label>Telefon</label>
            <input
              type="text"
              value={editClientData.nr_telefonu}
              onChange={e => setEditClientData({ ...editClientData, nr_telefonu: e.target.value })}
            />
          </section>

          <section className="form-section">
            <h4>Kontakt i przeglądy</h4>
            <label>Rabat (%)</label>
            <input
              type="number"
              value={editClientData.rabat || 0}
              onChange={e => setEditClientData({ ...editClientData, rabat: e.target.value })}
            />
            <label>Termin kontaktu</label>
            <input
              type="date"
              value={editClientData.kontakt || ''}
              onChange={e => setEditClientData({ ...editClientData, kontakt: e.target.value })}
            />
            <label>Cel kontaktu</label>
            <textarea
              value={editClientData.cel_kontaktu || ''}
              onChange={e => setEditClientData({ ...editClientData, cel_kontaktu: e.target.value })}
            />
            <label>
              <input
                type="checkbox"
                checked={!!editClientData.rezygnacja_z_przegladow}
                onChange={e => setEditClientData({ ...editClientData, rezygnacja_z_przegladow: e.target.checked })}
              />
              Rezygnacja z przeglądów
            </label>
            {editClientData.rezygnacja_z_przegladow && (
              <>
                <label>Powód rezygnacji</label>
                <textarea
                  value={editClientData.powod_rezygnacji || ''}
                  onChange={e => setEditClientData({ ...editClientData, powod_rezygnacji: e.target.value })}
                />
              </>
            )}
          </section>

          <section className="form-section">
            <h4>RODO i zgody</h4>
            <label>Grupa kliencka</label>
            <input
              type="text"
              value={editClientData.grupa_kliencka || ''}
              onChange={e => setEditClientData({ ...editClientData, grupa_kliencka: e.target.value })}
            />
            <label>
              <input
                type="checkbox"
                checked={!!editClientData.rodo_posprzedazowe}
                onChange={e => setEditClientData({ ...editClientData, rodo_posprzedazowe: e.target.checked })}
              />
              Zgoda RODO po-sprzedażowe
            </label>
            <label>
              <input
                type="checkbox"
                checked={!!editClientData.rodo_marketingowe}
                onChange={e => setEditClientData({ ...editClientData, rodo_marketingowe: e.target.checked })}
              />
              Zgoda RODO marketingowe
            </label>
          </section>

          <section className="form-section">
            <h4>Status firmy</h4>
            <label>
              <input
                type="checkbox"
                checked={editClientData.czy_firma}
                onChange={e => setEditClientData({ ...editClientData, czy_firma: e.target.checked })}
              />
              Czy firma?
            </label>
            {editClientData.czy_firma && (
              <>
                <label>NIP</label>
                <input
                  type="text"
                  value={editClientData.nip || ''}
                  onChange={e => setEditClientData({ ...editClientData, nip: e.target.value })}
                />
                <label>REGON</label>
                <input
                  type="text"
                  value={editClientData.regon || ''}
                  onChange={e => setEditClientData({ ...editClientData, regon: e.target.value })}
                />
                <label>Numer konta</label>
                <input
                  type="text"
                  value={editClientData.numer_konta || ''}
                  onChange={e => setEditClientData({ ...editClientData, numer_konta: e.target.value })}
                />
              </>
            )}
          </section>

          <section className='form-section'>
            <>
              <label>Notatka</label>
              <input 
              type="textarea"
              value={editClientData.notatka || ''}
              onChange={e => setEditClientData({ ...editClientData, notatka: e.target.value })}
              />
            </>


          </section>

          <div className="form-actions">
            {canEditClient ? <button onClick={handleSaveClient}>Zapisz</button> : null}
            {canEditClient ? <button onClick={handleCancelEditClient}>Anuluj</button> : null}
          </div>
        </div>
      ) : (
        <div className="client-details-grid">
          <div className="card">
            <h4>Dane podstawowe</h4>
            <p><strong>Imię:</strong> {klient.imie}</p>
            <p><strong>Nazwisko:</strong> {klient.nazwisko}</p>
            <p><strong>Email:</strong> {klient.adres_email}</p>
            <p><strong>Telefon:</strong> {klient.nr_telefonu}</p>
          </div>

          <div className="card">
            <h4>Kontakt i przeglądy</h4>
            <p><strong>Rabat:</strong> {klient.rabat ? `${klient.rabat}%` : 'Brak'}</p>
            <p><strong>Termin kontaktu:</strong> {formatDate(klient.kontakt)}</p>
            <p><strong>Cel kontaktu:</strong> {klient.cel_kontaktu || 'Brak'}</p>
            <p><strong>Przeglądy:</strong> {klient.rezygnacja_z_przegladow ? 'Rezygnacja' : 'Aktywne'}</p>
            {klient.rezygnacja_z_przegladow && (
              <p><strong>Powód rezygnacji:</strong> {klient.powod_rezygnacji}</p>
            )}
          </div>

          <div className="card">
            <h4>RODO i zgody</h4>
            <p><strong>Grupa kliencka:</strong> {klient.grupa_kliencka || 'Brak'}</p>
            <p><strong>Zgoda po-sprzedażowa:</strong> {klient.rodo_posprzedazowe ? 'Tak' : 'Nie'}</p>
            <p><strong>Zgoda marketingowa:</strong> {klient.rodo_marketingowe ? 'Tak' : 'Nie'}</p>
          </div>

          <div className="card">
            <h4>Status firmy</h4>
            <p>{klient.czy_firma ? 'Firma' : 'Osoba fizyczna'}</p>
            {klient.czy_firma && (
              <>
                <p><strong>NIP:</strong> {klient.nip || 'Brak'}</p>
                <p><strong>REGON:</strong> {klient.regon || 'Brak'}</p>
                <p><strong>Nr konta:</strong> {klient.numer_konta || 'Brak'}</p>
              </>
            )}
          </div>

          <div className='card'>
            <h4>Notatka</h4>
            <p>{klient.notatka}</p>  
          </div> 

            <div className="files-section">
            {/* Lewy panel: upload */}
            {canEditClient ? <div className="files-column">
              <h3>Dodaj pliki</h3>
              <input
                type="file"
                multiple
                accept=".pdf,.jpeg,.jpg,.png,.tiff,.docx,.xlsx"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleClientFilesChange}
              />
              <button type="button" onClick={handleChooseFilesClick}>
                Wybierz pliki
              </button>
              {clientFiles.length > 0 && (
                <ul className="selected-files-list">
                  {clientFiles.map((file, idx) => (
                    <li key={idx}>
                      {file.name} ({(file.size/1024/1024).toFixed(2)} MB)
                      <button
                        type="button"
                        onClick={() => handleRemoveFile(idx)}
                        className="remove-file-btn"
                      >
                        <FiX />
                      </button>
                    </li>
                  ))}
                </ul>
              )}
              {clientFiles.length > 0 && (
                <>
                  <button
                    type="button"
                    onClick={handleChooseFilesClick}
                    disabled={uploadingFiles}
                  >
                    Dodaj kolejny
                  </button>
                  <button
                    type="button"
                    onClick={handleUploadFiles}
                    disabled={uploadingFiles}
                  >
                    {uploadingFiles ? 'Wysyłanie...' : 'Wyślij pliki'}
                  </button>
                </>
              )}
            </div> : null}

            {/* Prawy panel: lista istniejących plików */}
             <div className="files-column">
            <h3>Pliki klienta</h3>
            <ul className="existing-files-list">
              {existingFiles.map(f => (
                <li key={f.id_pliku} className="existing-file-row">
                  <span
                    onMouseEnter={e => handleMouseEnter(f, e)}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                    className="file-name-link"
                  >
                    {f.nazwa_oryginalna}
                  </span>
                  <button
                    type="button"
                    onClick={() => handleDownload(f)}
                    className="btn btn-sm btn-primary"
                  >
                    Pobierz
                  </button>
                  {canEditClient ? <button
                    type="button"
                    onClick={() => handleDeleteClientFile(f)}
                    className="btn btn-sm btn-danger"
                    style={{ marginLeft: 8 }}
                  >
                    Usuń
                  </button> : null}
                </li>
              ))}
            </ul>

            {/* 3. Tooltip z podglądem */}
            {previewUrl && (
              <div
                className="file-preview-tooltip"
                style={{
                  position: 'fixed',
                  top: previewPos.y,
                  left: previewPos.x,
                  border: '1px solid #ccc',
                  background: '#fff',
                  padding: 4,
                  zIndex: 1000,
                  maxWidth: 200,
                  maxHeight: 200,
                  overflow: 'hidden'
                }}
              >
                {previewType === 'image'
                  ? <img src={previewUrl} style={{ maxWidth: '100%', maxHeight: '100%' }} alt="Podgląd" />
                  : <object data={previewUrl} type="application/pdf" width="200" height="200">PDF</object>
                }
              </div>
            )}
          </div>
          </div> 


            <SzczegolyKlientaTabela 
            uzytkownik={uzytkownik}
            klientId={klient.id_klient}
            klientData={klient}
            adresData={adresy}
            />

        </div>
      )}

      <div>
        <h3>Adresy</h3>
        <table>
          <thead>
          <tr>
              <th>Miasto</th>
              <th>Kod pocztowy</th>
              <th>Ulica</th>
              <th>Nr Domu</th>
              <th>Nr Lokalu</th>
              <th>Notatka</th>
              <th>Urządzenia</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {adresy.map(adres => (
              <React.Fragment key={adres.id_adres}>
                <tr className="address-row">

                  {editingAddressId === adres.id_adres ? (
                    // 🔹 Tryb edycji – zamieniamy pola na inputy
                    <>
                      <td>
                        <input 
                          type="text" 
                          style={{width:'unset'}}
                          value={editAddressData.miasto} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, miasto: e.target.value })} 
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          style={{width:'unset'}}
                          value={editAddressData.kod_pocztowy} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, kod_pocztowy: e.target.value })} 
                        />
                      </td>
                      <td>
                        <input 
                          type="text"
                          style={{width:'unset'}} 
                          value={editAddressData.ulica} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, ulica: e.target.value })} 
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          style={{width:'unset'}}
                          value={editAddressData.nr_domu} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, nr_domu: e.target.value })} 
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          style={{width:'unset'}}
                          value={editAddressData.nr_lokalu || ''} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, nr_lokalu: e.target.value })} 
                        />
                      </td>
                      <td>
                        <input 
                          type="text" 
                          style={{width:'unset'}}
                          value={editAddressData.notatka || ''} 
                          onChange={(e) => setEditAddressData({ ...editAddressData, notatka: e.target.value })} 
                        />
                      </td>
                      <td>
                        {canEditClient ? <button onClick={handleSaveAddress}>Zapisz</button> : null}
                        {canEditClient ? <button onClick={handleCancelEditAddress}>Anuluj</button> : null}
                      </td>
                    </>
                  ) : (
                    // 🔹 Normalny tryb wyświetlania danych
                    <>
                      <td>{adres.miasto}</td>
                      <td>{adres.kod_pocztowy}</td>
                      <td>{adres.ulica}</td>
                      <td>{adres.nr_domu}</td>
                      <td>{adres.nr_lokalu || '-'}</td>
                      <td>{adres.notatka || '-'}</td>


                      <td>
                        <button onClick={() => toggleExpandAddress(adres.id_adres)}>Pokaż</button>
                      </td>
                      <td>
                        {canEditClient ? <button onClick={() => handleStartEditAddress(adres)}>Edytuj</button> : null}
                        {canDeleteClient ? <button onClick={() => handleDeleteAddress(adres.id_adres)}>Usuń</button> : null}
                        {canEditClient ? <button onClick={() => openAddDeviceModal(adres.id_adres)}>Dodaj urządzenie</button> : null}
                      </td>
                    </>
                  )}
                </tr>
                {expandedAddresses[adres.id_adres] && (
                  <tr>
                    <td colSpan="8">
                      
                          <div className="device-header">Urządzenia dla adresu: {adres.miasto}, {adres.ulica} {adres.nr_domu}</div>
                          <table className="device-table">
                            <thead>
                              <tr>
                                <th>Nazwa</th>
                                <th>Model</th>
                                <th>Nr seryjny</th>
                                <th>Rodzaj</th>
                                <th>Typ</th>
                                <th>Notatka</th>
                                <th>Akcje</th>
                              </tr>
                            </thead>
                            <tbody className='tabela-urzadzenia'>
                              {urzadzenia[adres.id_adres] && urzadzenia[adres.id_adres].length > 0 ? (
                                urzadzenia[adres.id_adres].map(urzadzenie => (
                                  <tr key={urzadzenie.id_urzadzenie}>
                                    {editingDeviceId === urzadzenie.id_urzadzenie ? (
                                      // 🔹 Tryb edycji – zamieniamy pola na inputy
                                      <>
                                        <td><input type="text" style={{width:'unset'}} value={editDeviceData.nazwa} onChange={(e) => setEditDeviceData({ ...editDeviceData, nazwa: e.target.value })} /></td>
                                        <td><input type="text" style={{width:'unset'}} value={editDeviceData.model} onChange={(e) => setEditDeviceData({ ...editDeviceData, model: e.target.value })} /></td>
                                        <td><input type="text" style={{width:'unset'}} value={editDeviceData.numer_seryjny} onChange={(e) => setEditDeviceData({ ...editDeviceData, numer_seryjny: e.target.value })} /></td>
                                        <td>
                                          <select style={{width:'unset'}} value={editDeviceData.rodzaj} onChange={(e) => setEditDeviceData({ ...editDeviceData, rodzaj: e.target.value })}>
                                            <option value="Split">Split</option>
                                            <option value="Multi Split">Multi Split</option>
                                            <option value="Kaseta">Kaseta</option>
                                            <option value="Kaseta Multi">Kaseta Multi</option>
                                            <option value="Inne">Inne</option>
                                          </select>
                                        </td>
                                        <td>
                                          <select style={{width:'unset'}} value={editDeviceData.typ} onChange={(e) => setEditDeviceData({ ...editDeviceData, typ: e.target.value })}>
                                            <option value="Klimatyzacja">Klimatyzacja</option>
                                            <option value="Pompa Ciepła">Pompa Ciepła</option>
                                            <option value="Inne">Inne</option>
                                          </select>
                                        </td>
                                        <td><input type="text" style={{width:'unset'}} value={editDeviceData.uwagi} onChange={(e) => setEditDeviceData({ ...editDeviceData, uwagi: e.target.value })} /></td>
                                        <td>
                                          {canEditClient ? <button onClick={handleSaveDevice}>Zapisz</button> : null}
                                          {canEditClient ? <button onClick={handleCancelEdit}>Anuluj</button> : null}
                                        </td>
                                      </>
                                    ) : (
                                      // 🔹 Normalny tryb wyświetlania danych
                                      <>
                                        <td>{urzadzenie.nazwa}</td>
                                        <td>{urzadzenie.model}</td>
                                        <td>{urzadzenie.numer_seryjny}</td>
                                        <td>{urzadzenie.rodzaj}</td>
                                        <td>{urzadzenie.typ}</td>
                                        <td>{urzadzenie.uwagi || '-'}</td>
                                        <td>
                                          {canEditClient ? <button onClick={() => handleStartEdit(urzadzenie)}>Edytuj</button> : null}
                                          {canDeleteClient ? <button onClick={() => handleDeleteDevice(urzadzenie.id_urzadzenie, adres.id_adres)}>Usuń</button> : null}
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7">Brak urządzeń</td>
                                </tr>
                              )}
                            </tbody>
                        </table>
                      
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <OknoEdycji isOpen={showAddressForm && canEditClient} onClose={() => setShowAddressForm(false)}>
        <FormularzAdresu onSave={handleAddAddress} onCancel={() => setShowAddressForm(false)} klientId={klientId} />
      </OknoEdycji>
      <OknoEdycji isOpen={!!showDeviceForm && canEditClient} onClose={closeAddDeviceModal}>
        {showDeviceForm && (
            <FormularzUrzadzen
                onSave={(newDevice) => handleAddDevice(newDevice)}
                onCancel={closeAddDeviceModal}
                adresy={adresy}
                selectedAdresId={showDeviceForm} // Przekazujemy ID adresu
            />
        )}
    </OknoEdycji>
    <OknoEdycji isOpen={showOrderForm && canCreateOrder} onClose={() => setShowOrderForm(false)}>
      <FormularzZlecenia
        uzytkownik={uzytkownik}
        onZamknij={() => setShowOrderForm(false)}
        clientId={klient.id_klient}
        defaultAddress={adresy.length > 0 ? adresy[0] : null}
      />
    </OknoEdycji>


    </div>
  );
}

export default SzczegolyKlienta;